/* eslint-disable */
import {AGREGAR} from 'redux/types/app';

const estadoInicial = {
    tecnicos: []
}

const tecnicosReducer = (state = estadoInicial, action) => {
    switch (action.type) {
        case AGREGAR:
            state.tecnicos = action.payload;
            return { ...state }
        default:
            return state;
    }
}

export default tecnicosReducer;